import c, { useState as L, useMemo as v } from "react";
import { useTranslation as A } from "react-i18next";
import { I18N as y } from "../../../../../../js/i18n/index.js";
import { ActionButtonsType as S } from "../../../shared/actions.enum.js";
import { ServiceType as C } from "../../../../../../common/shared/serviceType.js";
import h from "../../../../../features/landing/hooks/useDomainCustomization.js";
import { getBtnActionText as R } from "../../../SharedLanding/i18n-helpers.js";
import { AddressValidationStatus as z } from "../../shared/address-validation-status.enum.js";
const E = {
  isLoading: !0,
  getTextTranslations: () => ({}),
  getRotativeTranslations: () => [],
  getActionTranslation: () => "",
  getScopeLocations: () => [],
  loader: null,
  setLoader: () => {
  },
  lang: "en"
}, I = c.createContext(E);
function O({
  children: u,
  landing: m
}) {
  const { i18n: p } = A(), { status: T, data: e, isFetching: r } = h(m), [i, d] = L(null), x = v(() => {
    var g;
    const a = y.getPriorityLanguage(
      ((g = navigator == null ? void 0 : navigator.languages) == null ? void 0 : g.map((t) => t.split("-")[0])) ?? [],
      (e == null ? void 0 : e.settings.configuration.supportedLanguages) ?? []
    ), l = (t, o) => {
      var n;
      return ((n = e == null ? void 0 : e.settings[t].text) == null ? void 0 : n[o || a]) ?? {};
    };
    return {
      getTextTranslations: l,
      getRotativeTranslations: (t, o) => {
        var s;
        return (((s = l(t)) == null ? void 0 : s[o]) || []).filter((f) => f.length > 0);
      },
      getActionTranslation: (t) => {
        var n, s;
        let o = ((n = t.texts) == null ? void 0 : n[a]) || "";
        return t.type === S.CUSTOM_LINK && o.length === 0 && (o = ((s = t.texts) == null ? void 0 : s[a]) || ""), o.length ? o : R(t.type, p);
      },
      getScopeLocations: (t) => (e == null ? void 0 : e.settings.configuration.scope.filter((o) => {
        var n, s;
        return ((s = (n = o.services) == null ? void 0 : n[t === C.TAKEAWAY ? "takeaway" : "delivery"]) == null ? void 0 : s.status) === z.ACTIVE;
      })) ?? [],
      configuration: e,
      isLoading: r,
      loader: i,
      setLoader: d,
      lang: a
    };
  }, [e, r, i, T]);
  return /* @__PURE__ */ c.createElement(I.Provider, { value: x }, u);
}
export {
  I as CustomizationContext,
  O as CustomizationProvider
};
//# sourceMappingURL=context.js.map
